import React from 'react';
import LegalPageTemplate from '../../components/legal/LegalPageTemplate';

const PrivacyPage: React.FC = () => {
  return <LegalPageTemplate sectionKey="privacy" />;
};

export default PrivacyPage;